export default {
  hasAudio: state => !!state.audio,
  hasVideo: state => !!state.video,
};
